import type { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import { getHandleActionKeyDown } from '@elfsight/widget-utils';

interface CloseProps extends HTMLAttributes<HTMLDivElement> {
  onClick: () => void;
}

export function Close({ onClick, ...forwardingProps }: CloseProps) {
  return (
    <CloseComponent
      aria-label="Close"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={getHandleActionKeyDown(onClick)}
      {...forwardingProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <path d="M14.128 2.815L8.943 7.999l5.185 5.186-.943.943L8 8.942l-5.185 5.186-.943-.943L7.057 8 1.872 2.815l.943-.943L8 7.057l5.185-5.185z" />
      </svg>
    </CloseComponent>
  );
}

export const CloseComponent = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 32px;
  background-color: rgba(255, 255, 255, 0.08);
  position: absolute;
  left: calc(100% + 18px);
  top: 18px;
  cursor: pointer;
  transition: 0.3s ease all;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;

  svg {
    fill: #fff;
  }

  &:hover,
  &:focus-visible {
    background-color: rgba(255, 255, 255, 0.3);
  }

  ${focusVisibleMixin()}

  ${({ theme: { windowWidth } }) =>
    windowWidth <= 608 &&
    css`
      left: auto;
      right: 16px;
      top: 16px;
      background-color: rgba(255, 255, 255, 0.75);

      &:hover {
        background-color: rgba(255, 255, 255, 1);
      }

      svg {
        fill: #111;
      }
    `};
`;
